<template>
  <div id="panorama" style="height: 100%">
    <img :src="src" alt="Preview" class="w-100 h-100" style="object-fit: cover;">
  </div>
</template>
<script>
/* global pannellum */
export default {
  props: {
    src: {
      type: String,
      default: 'https://pannellum.org/images/alma.jpg',
    },
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      pannellum.viewer('panorama', {
        type: 'equirectangular',
        panorama: this.src,
        autoLoad: true,
      });
    },
  },
};
</script>
